// Couleurs du widget Texte : pastilles proposées (fond de la carte, titre, texte) ; toute couleur #rrggbb est aussi acceptée
export const NOTE_BACKGROUNDS = [
  { key: null, color: '#ffffff', label: 'none' },
  { key: 'plum', color: '#f6f1fa', label: 'plum' },
  { key: 'grey', color: '#f4f5f8', label: 'grey' },
  { key: 'yellow', color: '#fff8e1', label: 'yellow' },
  { key: 'green', color: '#e9f8f0', label: 'green' },
  { key: 'blue', color: '#ebf2fe', label: 'blue' },
  { key: 'red', color: '#fdeeee', label: 'red' }
]

export const NOTE_TEXT_COLORS = [
  { key: null, color: '#121826', label: 'default' },
  { key: 'plum', color: '#6b1f4d', label: 'plum' },
  { key: 'grey', color: '#555e75', label: 'grey' },
  { key: 'green', color: '#1a7f4b', label: 'green' },
  { key: 'blue', color: '#1a56c4', label: 'blue' },
  { key: 'red', color: '#c62828', label: 'red' }
]

const HEX = /^#[0-9a-f]{6}$/i

// Couleur affichée d'une option : clé de pastille (anciennes valeurs) ou #rrggbb ; null = par défaut
export function resolveColor(value, list) {
  if (!value) return null
  if (HEX.test(value)) return value
  const preset = list.find(c => c.key === value)
  return preset ? preset.color : null
}

export const isCustomColor = (value, list) => !!value && HEX.test(value) && !list.some(c => c.key && c.color.toLowerCase() === value.toLowerCase())
